<template>
  <div v-if="(lang == 'br' || use_ba_support) && view.father_is_builderall">
    <div class="GridContainer">
        <div class="GridItem">
            <a class="BtnAssistance BtnAjust" :href="`${url_kwowledgebase}`" target="_blank"
               data-toggle="tooltip"
               data-placement="bottom"
               :title=" view.is_free_plan ? translation.label_require_upgrade : translation.new_knowledgebase">
                <div class="Logo">
                    <img class="Kwowledgebase" src="/internacional/public/office5/img/header/help.svg">
                </div>
                <div class="BtnText" id="Color1">
                    {{ translation.label_btn_help }}
                </div>
            </a>
        </div>
        <div class="GridItem">
            <a class="BtnSupport BtnAjust" :href="`${support_route}/chat`" target="_blank"
               data-toggle="tooltip"
               data-placement="bottom"
               :title="translation.zopim_concierge_title">
                <div class="Logo">
                    <img src="/internacional/public/office5/img/general-png/Icon_ionic-md-chatboxes.png">
                </div>
                <div class="BtnText" id="Color2">
                    {{ translation.label_btn_support }}
                </div>
            </a>
        </div>
    </div>
    <!-- <span v-if="show_alert_popover" id="newSupportPopover"></span> -->
  </div>
</template>

<script>
export default {
    name: "CardBtn",
    props: ["view"],
    data() {
        return {
            BtnAssistance: "AJUDA",
            BtnSupport: "SUPORTE",
            support_route: null,
            translation: [],
            lang: null,
            use_ba_support: false,
            show_alert_popover: false,
        };
    },

    mounted() {
        window.addEventListener('load', () => {
            this.handleHelpPopover();
        });
    },
    created() {
        this.support_route = this.view.support_route;
        this.translation = this.view['translation'];
        this.lang = this.view['lang'];
        this.use_ba_support = this.view['use_ba_support'];

        let popoverClosed = window.localStorage.getItem('support_popover_closed');
        this.show_alert_popover = this.lang != 'br' && this.use_ba_support && popoverClosed == null  && this.view.father_is_builderall;

    },

    methods: {
        handleHelpPopover (){

            let popoverClosed = window.localStorage.getItem('support_popover_closed');

            // show rule
           if (this.show_alert_popover) {

                let titleText = this.translation.new;
                let closeBtnText = 'OK!';
                let bodyText = this.translation.text_support_popover;

                // set popover style
                var style = document.createElement('style');
                style.type = 'text/css';
                style.innerHTML = '.popover { min-width: 370px; }';
                document.getElementsByTagName('head')[0].appendChild(style);

                // popover setting
                // $('#newSupportPopover').popover({
                //     placement: 'bottom',
                //     html : true,
                //     title : titleText,
                //     content : `<div style="font-size: 14px;">${bodyText}</div><button class="btn btn-xs btn-primary" style="float: right; margin: 10px 0px; background-color: #0080fc; padding: 3px 16px; border-color: #0080fc;" id="helpPopoverSupportClose">${closeBtnText}</buttons>`,
                //     animation: true
                // })

                // show popover with delay
                // setTimeout(function(){
                //     $('#newSupportPopover').popover('show')
                // }, 500);

                // handle close button click
                // $('#newSupportPopover').on('shown.bs.popover', function () {
                //     let button = document.getElementById('helpPopoverSupportClose');
                //     if (!!button)
                //     {
                //         button.addEventListener('click', function(){
                //             $('#newSupportPopover').popover('hide');
                //             localStorage.setItem('support_popover_closed', '1');
                //         });
                //     }
                // });
           }
        },
    },

    filters: {
    },

    computed: {
        url_kwowledgebase() {
            if (this.view.is_free_plan == true) {
                return this.view.handler_routes.rota_office_upgrade + '?is_free_plan=true'
            } else {
                return this.view.url_kwowledgebase
            }
        }
    },

    watch: {
    }
};
</script>

<style scoped lang="scss">
@import "../../../../../scss/extras/_variables";
.GridContainer {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  grid-gap: 10px;

    .GridItem {
        font-size: 30px;
        text-align: center;

        .BtnAssistance {
            display: grid;
            grid-template-columns: auto auto;
            justify-content: center;
            align-items: center;
            grid-gap: 2px;
            background-color: #ffff;
        }
        .BtnSupport {
            display: grid;
            grid-template-columns: auto auto;
            justify-content: center;
            align-items: center;
            grid-gap: 2px;
            background-color: #0080fc;
        }
        .BtnAjust {
            height: 40px;
            // width: 140px;
            position: relative;
            border-radius: 6px;
            box-shadow: 1px 1px 1px #dbdee2;

            width: fit-content;
            padding: 0 10px;
	        min-width: 140px;
        }
    }
}
//@media (max-width: 400px) {
//    .GridContainer {
//        display: grid;
//        grid-template-columns: auto;
//        grid-template-rows: auto auto;
//        justify-content: space-between;
//        grid-gap: 10px;
//    }
//}

.BtnText {
    padding: 2px 0 0 .3rem;
    font-family: $dv5-font1;
    font-size: 1rem;
    font-weight: 900;
    text-align: center;
}
.Kwowledgebase{
    width: 1.5em;
    height: auto;
}
#Color1 {
    color: #5485e5;
}
#Color2 {
    color: #ffffff;
}
@media (max-width: 400px) {
    .GridContainer {
        grid-template-columns: 1fr;
        justify-content: stretch;
        row-gap: 1em;
        margin-bottom: 1em;
        .GridItem{
            width: 100%;
            .BtnAjust{
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/tutorial/components/CardBtn.vue